"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.constructEventError = exports.throwCanClientError = exports.isLocalStorageSupported = exports.parseEvaluationResult = void 0;
var CanClientError_1 = require("./CanClientError");
// utils
var parseEvaluationResult = function (evaluationResult) {
    return evaluationResult[0].result;
};
exports.parseEvaluationResult = parseEvaluationResult;
var isLocalStorageSupported = function () {
    return typeof window != "undefined" &&
        typeof window["localStorage"] != "undefined" &&
        window["localStorage"] != null;
};
exports.isLocalStorageSupported = isLocalStorageSupported;
var throwCanClientError = function (err) {
    throw new CanClientError_1.CanClientError(err);
};
exports.throwCanClientError = throwCanClientError;
var constructEventError = function (code, message) {
    return {
        code: code,
        message: message,
    };
};
exports.constructEventError = constructEventError;
//# sourceMappingURL=utils.js.map